import list from './list'
import detail from './detail'

const importantNotice = {
  path: 'importantNotice',
  component: resolve => require(['../../../../pages/user/course/importantnotice'], resolve),
  redirect: 'importantNotice/list',
  children: [
    list,
    detail
  ]
}

export default importantNotice



// WEBPACK FOOTER //
// ./src/router/user/course/importantnotice/index.js